/**
 * All the routes for the Interviewee Video Interview.
 */
angular.module('App.video.routes', ['ngRoute', 'jv.Common.Jobvite.Urls', 'jv.jobseeker.playbackVideo', 'jv.video.interviewee.question.controller', 'jv.video.interview.review.controller'])
    .constant('partials', [
        //VA: Expired or Complete interview.
        {
            url: '/UnreachableInterview/:type/:interviewId', //type -> 'expired', 'complete'
            routing: {
                templateUrl: '{0}/video/jobseeker/videoUnreachable.html',
                controller: 'VideoCtrl'
            }
        },
        {
            url: '/UnreachableInterview/:type', //type ->  'browserUnsupported'
            routing: {
                templateUrl: '{0}/video/jobseeker/videoUnreachable.html',
                controller: 'VideoCtrl'
            }
        },{
            url: '/Interview/:state/:type/:interviewId', //state: setup //type -> 'recordInterview', 'practiceInterview'
            routing: {
                templateUrl: '{0}/video/jobseeker/jobseekerSetup.html',
                controller: 'IntervieweeQuestionCtrl'
            }
        }, {
            url: '/Interview/:state/:type/:interviewId/:actualId', //State: setup //type -> 'recordInterview', 'practiceInterview'
            routing: {
                templateUrl: '{0}/video/jobseeker/jobseekerSetup.html',
                controller: 'IntervieweeQuestionCtrl'
            }
        }, {
            url: '/Interview/:type/:interviewId', //type -> 'recordInterview', 'practiceInterview'
            routing: {
                templateUrl: '{0}/video/jobseeker/jobseekerInterviewQuestion.html',
                controller: 'IntervieweeQuestionCtrl'
            }
        }, {
            url: '/Playback/:type/:interviewId', // type -> 'actualInterview', 'practiceInterview'
            routing: {
                templateUrl: '{0}/video/jobseeker/jobseekerPlaybackReview.html',
                controller: 'VideoPlaybackCtrl'
            }
        }, {
            url: '/Review/:type/:interviewId', //type-> summary, abandoned, expired, invalid
            routing: {
                templateUrl: '{0}/video/jobseeker/jobseekerReviewMessages.html',
                controller: 'IntervieweeReviewCtrl'
            }
        }
    ])
    .config(['$routeProvider', 'partials', '$jobviteUrls',
        function($routeProvider, partials, $jobviteUrls) {
            angular.forEach(partials, function(route) {
                route.routing.templateUrl = route.routing.templateUrl.format($jobviteUrls.video);
                $routeProvider.when(route.url, route.routing);
            });
            $routeProvider.otherwise({
                redirectTo: '/Review/invalid'
            });
        }
    ]);
